module.exports = __webpack_public_path__ + "static/img/logistics-h5-4.b03fbb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/logistics-h5-4.png
// module id = ROgf
// module chunks = 34